import { render, staticRenderFns } from "./FAQPage.vue?vue&type=template&id=6ccbb5f8&scoped=true&lang=pug"
import script from "./FAQPage.vue?vue&type=script&lang=js"
export * from "./FAQPage.vue?vue&type=script&lang=js"
import style0 from "./FAQPage.vue?vue&type=style&index=0&id=6ccbb5f8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccbb5f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ccbb5f8')) {
      api.createRecord('6ccbb5f8', component.options)
    } else {
      api.reload('6ccbb5f8', component.options)
    }
    module.hot.accept("./FAQPage.vue?vue&type=template&id=6ccbb5f8&scoped=true&lang=pug", function () {
      api.rerender('6ccbb5f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/help_center/FAQPage.vue"
export default component.exports